export enum InstallationMode {
    web = 'web',
    pwa = 'pwa',
    twa = 'twa',
}
